import { __decorate, __metadata, __param } from "tslib";
import * as forge from 'node-forge';
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let SamlCertificateService = class SamlCertificateService {
    constructor(systemService) {
        this.systemService = systemService;
    }
    get cnAttrs() {
        return [{
                name: 'commonName',
                value: 'passport.patsnap.com',
            }, {
                name: 'countryName',
                value: 'CN',
            }, {
                name: 'stateOrProvinceName',
                value: 'JiangSu',
            }, {
                name: 'localityName',
                value: 'SuZhou',
            }, {
                name: 'organizationName',
                value: 'PatSnap',
            }, {
                name: 'organizationalUnitName',
                value: 'Core',
            }, {
                name: 'emailAddress',
                value: 'sre@patsnap.com',
            }];
    }
    get otherRegionAttrs() {
        return [{
                name: 'commonName',
                value: 'passport.patsnap.com',
            }, {
                name: 'countryName',
                value: 'Singapore',
            }, {
                name: 'stateOrProvinceName',
                value: 'Central Singapore',
            }, {
                name: 'localityName',
                value: 'High Street',
            }, {
                name: 'organizationName',
                value: 'PatSnap',
            }, {
                name: 'organizationalUnitName',
                value: 'Core',
            }, {
                name: 'emailAddress',
                value: 'sre@patsnap.com',
            }];
    }
    /**
     * 生成SAML证书和私钥
     */
    generateKeyPairs(year = 3) {
        try {
            // 生成RSA密钥对
            const keys = forge.pki.rsa.generateKeyPair(2048);
            // 创建证书
            const cert = forge.pki.createCertificate();
            cert.publicKey = keys.publicKey;
            cert.serialNumber = forge.util.bytesToHex(forge.random.getBytesSync(16));
            // 设置有效期
            cert.validity.notBefore = new Date();
            cert.validity.notAfter = new Date();
            cert.validity.notAfter.setFullYear(cert.validity.notBefore.getFullYear() + year);
            // 设置主题和签发者信息
            const attrs = this.systemService.IsCn ? this.cnAttrs : this.otherRegionAttrs;
            cert.setSubject(attrs);
            cert.setIssuer(attrs);
            // 设置扩展
            cert.setExtensions([{
                    name: 'basicConstraints',
                    cA: true,
                    critical: true,
                }, {
                    name: 'keyUsage',
                    keyCertSign: true,
                    digitalSignature: true,
                    nonRepudiation: true,
                    keyEncipherment: true,
                    dataEncipherment: true,
                }, {
                    name: 'subjectKeyIdentifier',
                }]);
            // 使用SHA-256签名证书
            cert.sign(keys.privateKey, forge.md.sha256.create());
            // 转换为PEM格式
            return {
                certificate: forge.pki.certificateToPem(cert),
                privateKey: forge.pki.privateKeyToPem(keys.privateKey),
                notAfter: cert.validity.notAfter,
            };
        }
        catch (error) {
            throw new Error('Failed to generate SAML certificate: ' + error);
        }
    }
    /**
     * 获取证书过期时间
     * @param certificate - 证书
     */
    certificateNotAfter(certificate) {
        try {
            const certificateVal = forge.pki.certificateFromPem(certificate);
            return certificateVal.validity.notAfter;
        }
        catch (error) {
            console.log(error);
        }
    }
};
SamlCertificateService = __decorate([
    injectable(),
    __param(0, inject(Symbols.SystemService)),
    __metadata("design:paramtypes", [Object])
], SamlCertificateService);
export { SamlCertificateService };
